<template>
    <div>
        <pixi-renderer :width="width" :height="height" ref="renderer">
            <container :x="0" :y="0">
                <sprite :x="0" :y="0" value="/assets/images/card.png?v=1"/>
                <qrcode :x="450" :y="60" :size="420" :value="qrcode"></qrcode>
                <pixi-text :x="227" :y="420" :value="name" :anchor=".5" :fontSize="56" />
<!--                <pixi-text :x="327" :y="185" :value="shop" :anchor=".5" :fontSize="32" />-->
            </container>
        </pixi-renderer>
    </div>
</template>

<script>
    import PixiRenderer from './PIXI/Renderer.vue'
    import Container from './PIXI/Container.vue'
    import Sprite from './PIXI/Sprite.vue'
    import Qrcode from './PIXI/QRcode.vue'
    import PixiText from './PIXI/Text.vue'

    export default {
        components: {
            PixiRenderer,
            Container,
            Sprite,
            Qrcode,
            PixiText,
        },

        props: [
            'qrcode',
            'name',
            'shop',
        ],

        data() {
            return {
                width: 935,
                height: 541,
            }
        },

        methods: {
            download() {
                this.$refs.renderer.download();
            },

            print() {
                this.$refs.renderer.print();
            },
        }
    }
</script>
